export default {
  首页: "홈",
  资产: "자산",
  币币: "동전",
  快捷买币: "코인을 빨리 구매하세요",
  "支持多种方式购买，购买更简单":
    "다양한 구매 방법을 지원하여 더욱 쉽게 구매할 수 있습니다.",
  语言设置: "언어 설정",
  确认恢复: "복구 확인",
  "输入邮箱，方便我们联系您": "우리가 연락할 수 있도록 이메일을 입력하세요",
  划转: "이동",
  行情: "인용 부호",
  "24H成交": "24시간 거래",
  累计收益: "누적 수입",
  充值时间: "재충전 시간",
  到期时间: "만료 시간",
  数量: "수량",
  操作: "작동하다",
  资产信息: "자산정보",
  复制地址: "주소 복사",
  链名称: "체인명",
  充值地址: "충전 주소",
  收款地址: "지불 주소",
  账单: "청구서",
  提现金额: "출금금액",
  接收地址: "수신 주소",
  交易密码: "거래 비밀번호",
  提现全部: "모두 철회",
  保存图片: "이미지 저장",
  输入您的交易密码: "거래 비밀번호를 입력하세요",
  确定: "확신하는",
  地址: "주소",
  注册时间: "등록 시간",
  取消: "취소",
  是否划转: "이전할지 여부",
  登录: "로그인",
  我的地址: "내 주소",
  登录密码和交易密码: "로그인 비밀번호 및 거래 비밀번호",
  注册: "등록하다",
  密码: "비밀번호",
  设置密码: "비밀번호 설정",
  重复密码: "비밀번호를 반복하세요",
  新密码: "새 비밀번호",
  确认新密码: "새 비밀번호 확인",
  充值: "충전하다",
  充值货币: "통화 충전",
  合约账户充值: "계약 계정 재충전",
  账户充值: "계정 재충전",
  其他: "다른",
  我的邀请码: "내 초대 코드",
  提现: "현금 인출",
  客服: "고객 서비스",
  持有详情: "개최 내용",
  请输入内容: "내용을 입력해주세요",
  邀请好友来领取奖励: "친구를 초대하여 보상을 받으세요",
  复制链接: "링크 복사",
  重复设置新的密码: "새 비밀번호를 설정하려면 반복하세요.",
  保存: "저장",
  我的: "내 거",
  "邮箱/手机号": "이메일/휴대전화번호",
  备注: "주목",
  地址管理: "주소 관리",
  我的团队: "내 팀",
  联系我们: "문의하기",
  竭诚为您服务: "당신의 서비스에 진심으로",
  提取收益: "수입 인출",
  带给我的收益: "나에게 가져온 수입",
  添加: "다음에 추가",
  名称: "이름",
  添加地址: "주소 추가",
  修改地址: "주소 수정",
  可提现: "철회 가능",
  安全中心: "보안센터",
  收益划转: "소득이전",
  通知中心: "알림 센터",
  "累计收益:": "누적 수입:",
  注册用户: "등록된 사용자",
  奖励规则: "보너스 규칙",
  帮助反馈: "피드백 도움말",
  邀请好友: "친구 초대",
  恢复身份: "정체성을 회복하다",
  选择语言: "언어 선택",
  设置新的密码: "새 비밀번호 설정",
  暂无活动: "아직 활동이 없습니다",
  "月增长量(+)": "월간 성장 (+)",
  可提取: "추출 가능",
  反馈类型: "피드백 유형",
  赠送: "포기하다",
  已经复制: "이미 복사되었습니다",
  保存成功: "성공적으로 저장되었습니다",
  划转成功: "전송 성공",
  过期: "만료됨",
  提交成功: "제출 성공",
  "服务器繁忙，稍后在试":
    "서버가 사용량이 많습니다. 나중에 다시 시도해 주세요.",
  全部: "모두",
  一级: "레벨 1",
  二级: "레벨 2",
  三级: "레벨 3",
  级: "수업",
  删除成功: "성공적으로 삭제되었습니다",
  选择地址: "주소 선택",
  不再提醒: "다시 알림 안함",
  "最小充值金额：": "최소 입금액:",
  选择币种: "통화 선택",
  输入投资金额: "투자금액을 입력하세요",
  输入账户密码: "계정 비밀번호를 입력하세요",
  投资: "투자하다",
  订单编号: "주문 번호",
  投资周期: "투자주기",
  投资资金: "투자 자금",
  投资时间: "투자 시간",
  状态: "상태",
  投资中: "투자",
  已到期: "만료됨",
  暂无数据: "아직 데이터가 없습니다",
  转入: "편입",
  邮箱: "우편",
  请输入邮箱: "이메일을 입력해주세요",
  请输入格式正确的邮箱: "올바른 이메일 형식을 입력하세요.",
  请输入验证码: "인증번호를 입력해주세요",
  获取验证码: "인증 코드 받기",
  请输入邀请码: "초대코드를 입력해주세요",
  今天: "오늘",
  昨天: "어제",
  最近七天: "지난 7일",
  邀请: "초대하다",
  购买数量: "구매 수량",
  产品详情: "제품 세부정보",
  币种: "통화",
  利息币种: "이자통화",
  理财类型: "재무관리 유형",
  产品费率: "제품 요율",
  进行中: "진행 중",
  每天: "매일",
  请输入搜索关键词: "검색 키워드를 입력해주세요",
  通知: "통지하다",
  查看更多: "더 보기",
  理财宝: "자산관리의 보물",
  周期: "주기",
  年利率: "연간 이자율",
  更多产品: "더 많은 제품",
  灵活存取: "유연한 액세스",
  稳定收益: "안정적인 수입",
  合约指南: "계약안내",
  资金划转出: "자금 이체",
  矿池收益: "마이닝 풀 수입",
  提现手续费: "출금수수료",
  冻结资金: "자금 동결",
  解冻资金: "자금 동결 해제",
  闪兑支出: "플래시 결제",
  闪兑收入: "즉각적인 교환수입",
  闪兑手续费: "즉시환매수수료",
  合约支出: "계약비용",
  合约收入: "계약 수익",
  输入的金额不可大于可用金额:
    "입력한 금액은 사용 가능한 금액보다 클 수 없습니다.",
  全部兑换成功: "모두 성공적으로 사용되었습니다",
  返回: "반품",
  查看历史: "기록 보기",
  闪兑历史: "플래시 교환 내역",
  支付: "지불하다",
  获取: "얻다",
  时间: "시간",
  手续费: "취급 수수료",
  折扣: "할인",
  价格: "가격",
  逐仓: "고립된 위치",
  全仓: "전체 창고",
  市价委托: "시장가 주문",
  限价委托: "제한 주문",
  请输入本金: "주체를 입력해주세요",
  请输入价格: "가격을 입력해주세요",
  "可做空/做多": "숏/롱 갈 수 있다",
  设置止盈止损: "이익실현 및 손절매 설정",
  止盈价: "이익실현 가격",
  止损价: "손실 중지 가격",
  成本: "비용",
  做多: "오래 가세요",
  做空: "짧은",
  仓位信息: "위치정보",
  一键平仓: "한 번의 클릭으로 포지션을 청산하세요",
  永续: "지속 가능한",
  浮动盈亏: "유동손익",
  平仓: "포지션 마감",
  反向开仓: "역방향 개방",
  一键撤销: "한 번의 클릭으로 실행 취소",
  倍杠杆: "배 레버리지",
  执行价格: "실행 가격",
  委托数量: "주문 수량",
  保证金: "여유",
  成交价: "거래가격",
  创建时间: "생성 시간",
  撤销: "취소",
  合约市场: "계약 시장",
  交易方向: "거래 방향",
  委托价格: "수수료 가격",
  委托金额: "수수료 금액",
  资金费率: "펀딩 비율",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "롱 트레이더와 숏 트레이더가 지불하는 반복 수수료로, 8시간마다 정산됩니다.",
  "资金费率为正，多方向空方支付资金费用。":
    "펀딩 비율은 양수이며, 롱 측이 숏 측에 펀딩 수수료를 지불합니다.",
  "资金费率为负，空方向多方支付资金费用。":
    "펀딩 비율은 음수이며, 짧은 당사자는 긴 당사자에게 펀딩 수수료를 지불합니다.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "리버스 포지션을 오픈하시겠습니까? 역방향 포지션을 오픈하면 현재 기간의 반대 포지션을 매수하게 됩니다.",
  "仓位止盈/止损": "포지션 이익실현/손절매",
  合约名称: "계약명",
  开仓价格: "개장 가격",
  指数价格: "지수 가격",
  止盈设置: "이익실현 설정",
  请输入止盈价: "이익 실현 가격을 입력하세요.",
  "当指数价格触达*时，将会触发委托平仓":
    "지수 가격이 *에 도달하면 포지션 청산 주문이 발동됩니다.",
  预计盈亏: "추정 손익",
  当前仓位: "현재 위치",
  平仓金额: "결산금액",
  仓位模式: "위치 패턴",
  全仓模式: "교차 위치 모드",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "계약 계좌의 사용 가능한 자금은 모두 사용 가능한 마진으로 간주됩니다. 포지션 손실이 계정 잔액을 초과하는 경우 해당 포지션은 청산되며 모든 마진과 포지션이 손실됩니다.",
  逐仓模式: "격리 마진 모드",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "계약 계정의 일정 금액의 증거금이 해당 포지션에 할당됩니다. 증거금 손실이 유지 증거금 수준 이하로 떨어지면 포지션이 청산됩니다. 격리 마진 모드에서는 해당 포지션의 마진을 늘리거나 줄일 수 있습니다.",
  "是否撤销？": "취소?",
  "是否一键撤销？": "클릭 한 번으로 취소하시겠습니까?",
  "是否一键平仓？": "한 번의 클릭으로 포지션을 청산하고 싶으신가요?",
  持仓保证金: "포지션 마진",
  风险率: "위험률",
  未实现盈亏: "미실현 손익",
  可用保证金: "사용 가능한 마진",
  净值: "순자산",
  账户余额: "계좌잔고",
  合约计算器: "계약 계산기",
  交易记录: "거래 내역",
  "*倍杠杆": "*X 레버리지",
  "平仓盈亏：": "마감 포지션의 이익과 손실:",
  时间筛选: "시간 필터",
  仓位类型: "직위 유형",
  订单状态: "주문 상태",
  订单类型: "주문 유형",
  平仓价格: "종가",
  持仓数量: "포지션 수량",
  "手续费(%)": "수수료(%)",
  平仓时间: "폐관 시간",
  平仓类型: "결산형",
  手动平仓: "수동 폐쇄",
  强制平仓: "강제청산",
  近1天: "지난 1일",
  近7天: "지난 7일",
  近30天: "지난 30일",
  近180天: "지난 180일",
  持仓: "위치",
  已取消: "취소",
  分时: "시간 공유",
  "24H额(USDT)": "24시간 금액(USDT)",
  "24H低": "24시간 최저",
  "24H量(BTC)": "24시간 거래량(BTC)",
  "24H高": "24시간 높이",
  "10秒": "10초",
  "30秒": "30초",
  "1分": "1점",
  "3分": "3점",
  "5分": "5점",
  "30分": "30분",
  "1小时": "1시간",
  "4小时": "4시간",
  "8小时": "8시간",
  "1天": "1일",
  "1周": "1주",
  "1月": "1월",
  单向持仓: "단방향 위치",
  杠杆: "지렛대",
  仓位: "위치",
  计算结果: "계산 결과",
  盈亏: "이익과 손실",
  收益率: "생산하다",
  计算结果仅供参考: "계산 결과는 참고용입니다.",
  成交后仓位大小: "거래 후 포지션 크기",
  "计算结果仅供参考,实际结果可能因费率差异":
    "계산 결과는 참고용이며, 환율 차이로 인해 실제 결과가 달라질 수 있습니다.",
  目标价格: "목표 가격",
  开始计算: "계산 시작",
  强平价格: "청산 가격",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "충전 전 반드시 충전 체인명을 확인하시기 바랍니다. 충전 오류가 있는 경우 자산을 회수할 수 없습니다. 최소 충전 금액은 *입니다. 이 금액보다 적으면 플랫폼에서 도착을 확인할 수 없습니다. * 이외의 자산을 이 주소로 재충전하지 마십시오. 자산을 회수하려면 플랫폼이 귀하를 대신하여 토큰을 발행하지 않습니다.",
  "最小输入*": "최소 입력*",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "최소 출금금액은 *이며, 출금수수료는 출금금액에서 차감됩니다. 코인을 출금하기 전에 반드시 지불 주소를 확인하고 확인하시기 바랍니다. * 이외의 주소로 *를 출금하지 마십시오. 그렇지 않으면 자산이 복구되지 않습니다. 플랫폼에서는 토큰 발행을 처리하지 않으므로 크라우드 펀딩 또는 ICO 주소에서 직접 돈을 인출하지 마십시오.",
  退出登录: "로그아웃",
  加仓: "위치에 추가",
  新增仓位: "새 위치 추가",
  输入加仓金额: "입금액을 입력하세요",
  "当前可用:": "현재 사용 가능:",
  资产账单: "자산 청구서",
  保存二维码: "QR 코드 저장",
  温馨提示: "친절한 팁",
  "请注意：您当前使用的网络": "참고: 현재 사용 중인 네트워크",
  输入提现地址: "출금주소를 입력하세요",
  "可用金额：": "사용 가능한 금액:",
  输入资产密码: "자산 비밀번호를 입력하세요",
  可用手续费: "사용 가능한 수수료",
  "折扣%": "할인%",
  实扣手续费: "실제 수수료 공제",
  实际到账: "실제 도착",
  未设置资产密码: "자산 비밀번호가 설정되지 않았습니다.",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "자산의 안전을 위해 출금 전 자산 비밀번호를 설정하시기 바랍니다.",
  热榜: "핫리스트",
  涨幅榜: "게이너 목록",
  跌幅榜: "패자 목록",
  成交额榜: "매출액 목록",
  关于我们: "회사 소개",
  登录密码: "로그인 비밀번호",
  设置: "설정",
  资产密码: "자산 비밀번호",
  修改登录密码: "로그인 비밀번호 변경",
  原密码: "원래 비밀번호",
  请输入新密码: "새로운 비밀번호를 입력해주세요",
  请输入原密码: "원래 비밀번호를 입력해주세요",
  确认密码: "비밀번호 확인",
  确定修改: "수정 확인",
  修改资产密码: "자산 비밀번호 수정",
  验证码: "인증코드",
  资产密码使用提示: "자산 비밀번호 사용 팁",
  "资产密码用于转移、提取资产和交易。":
    "자산 암호화폐는 자산을 이전, 인출하고 거래하는 데 사용됩니다.",
  "创建与登录密码不同的资产密码。":
    "로그인 비밀번호와 다른 자산 비밀번호를 만드세요.",
  "定期更改您的资产密码。": "자산 비밀번호를 정기적으로 변경하세요.",
  提币历史: "출금 내역",
  "金额/余额": "금액/잔고",
  "手续费/折扣": "수수료/할인 처리",
  自选: "선택 과목",
  现货: "현물 상품",
  市价: "시장 가격",
  止损设置: "손실정지 설정",
  合约K线图: "계약 K-라인 차트",
  "24H量": "24시간 수량",
  "24H额": "24시간 금액",
  合作指南: "협력 가이드",
  盈亏计算: "손익계산",
  当前可用: "현재 사용 가능",
  请输入加仓金额: "입금액을 입력해주세요",
  请重新输入加仓金额: "입금액을 다시 입력해 주세요",
  平仓数量: "마감 수량",
  欢迎登录: "로그인을 환영합니다",
  "忘记密码?": "비밀번호 찾기?",
  "还没有账号？": "아직 계정이 없나요?",
  立即注册: "지금 등록하세요",
  繁體中文: "중국어 번체",
  找回密码: "비밀번호 검색",
  下一步: "다음 단계",
  注册账户: "계정 등록",
  "请输入邀请码(选填)": "초대코드를 입력해주세요(선택)",
  谢邀豪礼: "푸짐한 선물 감사합니다",
  "24小时邀请好友排名": "24시간 친구랭킹 초대",
  "*人": "*사람들",
  "差*人": "나쁜* 사람들",
  "已超过10万人，每月轻松赚钱":
    "이미 10만명이 넘었고, 매달 쉽게 돈을 벌고 있습니다",
  最高: "제일 높은",
  邀请链接: "초대링크",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "플랫폼은 친구가 플랫폼에서 생성한 처리 수수료(현물, 계약, 레버리지, 플래시 교환)를 귀하와 공유합니다.",
  平台和您一起分享手续费: "플랫폼은 귀하와 처리 수수료를 공유합니다.",
  "*级": "*수업",
  规则: "규칙",
  我的好友: "내 친구들",
  好友详情: "친구 세부정보",
  获得好友佣金方案: "친구 커미션 플랜 받기",
  我的等级: "내 수준",
  我的邀请数据: "내 초대 데이터",
  当前等级: "현재 수준",
  平台奖励您: "플랫폼은 당신에게 보상을 제공합니다",
  最高可获取平台奖励: "얻을 수 있는 최고의 플랫폼 보상",
  邀请规则: "초대 규칙",
  "邀请*级有效好友": "*레벨의 유효한 친구 초대",
  好友等级: "친구 수준",
  人: "사람들",
  奖金派送: "보너스 분배",
  平台奖励: "플랫폼 보상",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "최종 해석권은 플랫폼에 있습니다. 플랫폼 보상 획득에 이상이 발견되면 모든 보상이 차감되며, 손실된 자산은 복구되지 않습니다.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "귀하의 계정은 유효한 계정이어야 합니다. 플랫폼은 유효한 계정 조건이 최소 * USDT 값(모든 통화의 계정 재충전)이라고 결정합니다.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "귀하가 초대하는 친구는 유효한 하위 친구여야 합니다. 플랫폼은 유효한 하위 친구가 (모든 통화의 계정 재충전) * USDT의 최소값이라고 결정합니다.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "초대자와 초대받는 사람의 계정은 동일한 IP에 속할 수 없습니다.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP 레벨은 초대한 1레벨 친구의 수에 따라 평가됩니다.",
  佣金成分: "커미션 구성요소",
  收益统计: "수익통계",
  昨日收益: "어제 수익",
  月收益: "월 소득",
  获取收益: "수입을 얻으세요",
  "总收益：": "총 수익:",
  "*级好友": "*친구",
  理财购买: "금융구매",
  期限: "용어",
  可用金额: "사용 가능 금액",
  预估收益: "예상 수익",
  申购上限: "구독 한도",
  项目剩余: "남은 프로젝트",
  "买入后预计*(SGT)开始计算收益。":
    "*(SGT)는 매수 후 수익 계산을 시작할 것으로 예상됩니다.",
  计息日: "이자 발생일",
  申购日: "구독 날짜",
  到账日: "도착일",
  到期自动续投: "만료 시 자동 갱신",
  申购: "신청",
  搜索理财项目: "금융 프로젝트 검색",
  超高年化随心选: "초고년화 수심",
  "自由选择理财币种，稳定超额收益":
    "금융통화를 자유롭게 선택하고 초과수익을 안정화",
  理财总资产: "총 금융자산",
  申购数量: "구독 수량",
  立即购买: "지금 구매하세요",
  年化收益率: "연간 수익률",
  理财订单: "재정관리명령",
  持有: "잡고 있다",
  申购份额: "구독 점유율",
  到账日期: "도착일",
  申购成功: "구독 성공",
  到期: "성숙함",
  是否选择做多: "롱을 선택할지",
  "可用余额为0 不能操作": "사용 가능한 잔액이 0이 되어 조작이 불가능합니다.",
  福利中心: "복지센터",
  奖励记录: "수상실적",
  我获取到的奖励: "내가 받은 보상",
  总价值: "총 가치",
  新手任务: "초보자 작업",
  身份认证: "신원인증",
  身份验证: "인증",
  去验证: "확인하기 위해",
  审核中: "검토중",
  已验证: "확인됨",
  认证失败: "인증 실패",
  基础认证: "기본인증",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "인증정보는 한번 확인되면 수정이 불가능하니, 반드시 정확한 정보를 입력해 주시기 바랍니다.",
  "国家/地区": "국가/지역",
  请选择: "선택해주세요",
  证件类型: "증서 종류",
  证件编码: "증명서 번호",
  身份证: "신분증",
  护照: "여권",
  驾驶证: "운전면허증",
  请输入编码: "증명서 번호 입려하세요",
  名字: "이름",
  请输入: "입력해주세요",
  中间名: "중간 이름",
  选填: "선택 과목",
  姓氏: "성",
  中国: "중국",
  身份上传: "신원 업로드",
  上传身份证: "신분증 업로드",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "위 자료는 JPG/JPEG/PNG 형식으로 업로드해야 하며, 사진의 선명한 모서리와 모서리가 손상되지 않고 밝기가 균일해야 합니다. 그리고 크기는 *M을 초과하지 않습니다.",
  确定提交: "제출 확인",
  去认证: "인증으로 이동",
  挑战任务: "도전 미션",
  注册认证任务: "인증업무 등록",
  完成注册认证即可领取: "등록증을 작성하신 후 받으실 수 있습니다.",
  领取奖励: "보상 청구",
  新人豪礼: "초보자 선물",
  "参与人数：": "참가자 수:",
  条件: "상태",
  入金量: "입금량",
  完成: "마치다",
  任务奖励: "과제 보상",
  距任务更新: "작업 업데이트",
  "条件：": "상태:",
  活动规则: "활동 규칙",
  奖励明细: "보상 내용",
  已获得: "획득",
  交易奖励: "거래 보상",
  Win奖励: "보상 획득",
  已领取: "받았다",
  亏损金额超过: "손실액이 초과됨",
  单笔开仓金额超过: "단일 개시 포지션의 금액이 초과되었습니다.",
  交易量: "거래량",
  待完成: "완료 예정",
  入金: "입금",
  盈利金额超过: "이익금액이 초과되었습니다.",
  开仓金额: "개시금액",
  开仓金: "개설비",
  盈利: "이익",
  亏损: "손실",
  领取: "받다",
  未领取: "수집되지 않음",
  待领取: "수집 예정",
  再交易: "다시 거래하다",
  即可获得: "당신은 얻을 수 있습니다",
  领取成功: "성공적으로 받았습니다",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. 모든 활동은 마지막 활동 시간을 기준으로 계산되며, 만료 후에는 소득이 무효화됩니다.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. 획득한 수입은 귀하의 바운티 계좌로 배분되며, 귀하의 필요에 따라 언제든지 현금을 교환 및 인출할 수 있습니다.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. 획득한 보상 화폐 종류는 작업 종류에 따라 분배됩니다.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. 최종 해석권은 플랫폼에 있습니다. 플랫폼의 작업 보너스를 차익거래하는 비정상적인 수단이 있는 것으로 확인되면 플랫폼은 귀하의 수입을 동결하고 청산할 권리가 있습니다.",
  成长学院: "성장 아카데미",
  "区块链 & 加密货币": "블록체인 및 암호화폐",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "암호화폐에 대한 원스톱 가이드를 통해 여러분의 암호화폐 여정을 안내합니다.",
  "全仓合约定单的全部保证金。": "교차 계약 주문에 대한 전체 마진입니다.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(계좌잔액 + (부동손익 - 취급수수료 - 익일 수수료) = 순자산 / 사용마진 * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "변동 손익은 '사용 가능 마진'에 직접적인 영향을 미칩니다. 미실현 손익이 증가하면 사용 가능 마진도 증가합니다.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "계좌잔고 - (사용마진) + (부동손익 - 취급수수료 - 익일수수료)",
  "注:可继续用于开仓的保证金。":
    "참고: 증거금은 계속해서 포지션을 여는 데 사용될 수 있습니다.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "계좌잔고 + (부동손익 - 취급수수료 - 익일수수료)",
  "注:当前的资金结余。": "참고: 현재 자금 잔액.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "사용할 수 없는 잔액을 포함하여 계약 계정의 전체 잔액을 의미합니다.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "참고: 위험률이 높을수록 위험은 낮아지고, 위험률이 낮을수록 위험은 높아집니다.",
  该功能尚未开发: "이 기능은 아직 개발되지 않았습니다.",
  重置密码: "비밀번호 재설정",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "8~20자를 입력하세요. 문자, 숫자, 특수문자를 포함해야 합니다.",
  修改成功: "수정 성공",
  输入验证码: "확인 코드를 입력하세요",
  输入密码: "비밀번호를 입력하세요",
  详情说明: "세부",
  已售罄: "매진",
  剩余期限: "남은 기간",
  限期: "사선",
  闪兑货币选择: "즉시 교환 통화 선택",
  地区选择: "지역 선택",
  "搜索国家/地区": "국가/지역 검색",
  "身份信息已提交，将在*小时内审核完成":
    "신원 정보가 제출되었으며 *시간 이내에 검토됩니다.",
  "选择国家/地区": "국가/지역 선택",
  "止盈价格需高于*": "이익 실현 가격은 *보다 높아야 합니다.",
  "止损价格需低于*": "손절매 가격은 *보다 낮아야 합니다.",
  "止盈价格需低于*": "이익 실현 가격은 *보다 낮아야 합니다.",
  "止损价格需高于*": "손절매 가격은 *보다 높아야 합니다.",
  教程详情: "튜토리얼 세부정보",
  请输入止损价: "손실정지가격을 입력해주세요",
  活期: "현재의",
  赎回后立即到账: "상환 직후",
  赎回: "구원",
  赎回理财: "환매재무관리",
  是否赎回当前的理财订单: "현재 재무 관리 명령을 상환할지 여부",
  维护: "유지하다",
  "系统正在维护中……": "시스템이 유지보수 중입니다...",
  合约: "계약",
  闪电兑换: "번개 교환",
  流水挖矿: "흐르는 물 채굴",
  邀请豪礼: "명품 선물을 초대하세요",
  计算器: "계산자",
  最新价: "최신 가격",
  涨跌幅: "증가 또는 감소",
  关注币种添加自选: "통화를 따라 원하는 선택을 추가하세요.",
  一键添加自选: "한 번의 클릭으로 나만의 옵션을 추가하세요",
  全标已读: "만점 읽기",
  无消息: "무소식",
  "暂时还没有收到任何消息通知哦!": "아직 메시지 알림을 받지 못했습니다!",
  没有更多数据: "더 이상 데이터가 없습니다",
  闪兑: "플래시 교환",
  从: "~에서",
  "可用余额：": "사용 가능한 잔액:",
  至: "에게",
  预览兑换结果: "상환 결과 미리보기",
  闪兑规则: "플래시 교환 규칙",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "마켓플래시 거래소는 변동될 수 있으니 실제 수령금액을 참고하시기 바랍니다.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "환율은 제3자에 의해 설정되며, 교환 비용 및 시장 변동으로 인해 귀하가 교환하는 환율이 시장 환율보다 높을 수 있으므로 진행하기 전에 주의 깊게 확인하시기 바랍니다.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "플랫폼은 거래소의 교환 비용을 충당하기 위해 각 교환에 대해 약 *%의 처리 수수료를 부과합니다.",
  确认汇兑: "교환 확인",
  您预估得到: "당신은 추정",
  汇兑: "교환",
  汇兑比例: "환율",
  刷新: "새로 고치다",
  兑换: "교환",
  没有更多了: "더 이상",
  搜索币种: "통화 검색",
  可用: "사용 가능",
  我知道了: "알겠어요",
  最新价格: "최신 가격",
  确认: "확인하다",
  最大: "최고",
  "风险率(%)": "위험률(%)",
  当前委托: "현재 주문",
  合作交易历史记录: "협력 거래 내역",
  重置: "다시 놓기",
  余额: "균형",
  现货账户: "자금 계정",
  合约账户: "계약계좌",
  WIN账户: "승리 계정",
  赏金账户: "현상금 계정",
  总资产折合: "전환된 총 자산",
  今日收益: "오늘의 수입",
  充币: "코인 입금",
  提币: "코인 출금",
  账户权益: "계정 권한",
  "数量/类别": "수량/범주",
  全部币种: "모든 통화",
  全部类型: "모든 유형",
  账单信息: "청구 정보",
  理财赎回: "재정적 상환",
  购买理财: "재무 관리 구매",
  收入: "소득",
  支出: "지출",
  到: "에게",
  资产划转: "자산 양도",
  "最少*": "최소*",
  "可用资产：": "사용 가능한 자산:",
  确认划转: "이체 확인",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "해당 계좌로 이체된 자산만 거래가 가능하며, 계좌 간 이체 시 수수료는 부과되지 않습니다.",
  币种账户选择: "통화 계정 선택",
  选择账户: "계정 선택",
  划转详情: "송금 세부정보",
  划转明细: "송금 세부정보",
  收入账单: "소득 계산서",
  支出账单: "비용 청구서",
  金额: "양",
  总收益: "총 수익",
  佣金: "수수료",
  用户名: "사용자 이름",
  "已领取：": "받았다:",
  "未领取：": "받지 못함:",
  "请选择国家/地区": "국가/지역을 선택해 주세요",
  请上传身份信息: "신원 정보를 업로드해 주세요.",
  请选择证件类型: "문서 유형을 선택하세요.",
  请填写证件编码: "ID번호를 입력해주세요.",
  请填写名字: "이름을 입력해주세요",
  请填写姓氏: "성을 입력해 주세요.",
  投资金额: "투자금액",
  天: "하늘",
  请输入手机号: "휴대폰번호를 입력해주세요",
  搜索: "찾다",
  搜索历史: "검색 기록",
  热门推荐: "인기 추천",
  "《Xspace Earn协议》": "Xspace 적립 프로토콜",
  我已了解并同意: "나는 이해하고 동의합니다",
  协议: "규약",
  Xspace官方中文交流群: "Xspace 공식 중국어 교류 그룹",
  Xspace官方英文交流群: "Xspace 공식 영어 커뮤니케이션 그룹",
  预计维护至: "예상되는 유지보수",
  更多功能: "기타 기능",
  下载APP: "앱 다운로드",
  理财: "재무 관리",
  推荐: "추천하다",
  Telegram官方中文频道: "텔레그램 공식 중국어 채널",
  Telegram官方英文频道: "텔레그램 공식 영어채널",
  官方邮箱: "공식 이메일",
  客服邮箱: "고객 서비스 이메일",
  上述信息最终解释权归官方所有:
    "위 정보의 최종 해석권은 해당 관계자에게 있습니다.",
  IOS版下载: "IOS 버전 다운로드",
  Android版下载: "안드로이드 버전 다운로드",
  "手续费=买入手续费+资金费率+卖出手续费":
    "취급수수료 = 매수수수료 + 펀딩요율 + 매도수수료",
  资金划转: "자금 이체",
  止盈: "이익을 얻으세요",
  止损: "손실을 막다",
  自动平仓: "자동 폐쇄",
  委托挂单: "대기 주문 위탁",
  买: "구입",
  卖: "팔다",
  "买入/做多": "매수/매수",
  "卖出/做空": "매도/공매도",
  详情: "세부",
  浮动涨跌: "위아래로 떠다니는",
  最小: "가장 작은",
  充币数量: "입금액",
  请输入充币数量: "입금액을 입력해주세요",
  支付截图: "결제 스크린샷",
  提交: "제출하다",
  上传驾驶证: "운전면허증 업로드",
  上传护照: "여권 업로드",
  加载中: "로드 중",
  上传成功: "업로드 성공",
  充值历史: "충전 내역",
  合约卖出手续费: "계약판매수수료",
  合约买入手续费: "계약 구매 수수료",
  系统加款: "시스템 결제",
  系统减款: "시스템 공제",
  合约资金费率: "계약자금비율",
  佣金分成: "커미션 지분",
  U本位合约: "U 표준 계약",
  资产管理: "자산관리",
  APP下载: "앱 다운로드",
  全球领先的数字理财平台: "세계 최고의 디지털 금융 관리 플랫폼",
  "即刻交易比特币、以太坊等上百种数字资产":
    "비트코인, 이더리움 및 수백 개의 기타 디지털 자산을 즉시 거래하세요",
  "24H涨跌幅": "24H 증가 및 감소",
  查看更多行情: "더 많은 견적 보기",
  近24小时成交量: "지난 24시간 동안의 거래량",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "다양한 거래 요구를 충족하기 위해 수백 개의 통화 및 계약 거래 쌍을 제공합니다. 이 플랫폼은 200개 국가 및 지역에서 2천만 명 이상의 사용자를 보유하고 있으며 세계 최고의 디지털 자산 서비스 플랫폼입니다.",
  用户国家分布: "사용자 국가 분포",
  用户数: "사용자 수",
  交易对: "거래쌍",
  服务支持: "서비스 지원",
  "随时随地，多平台终端交易": "언제 어디서나 멀티플랫폼 단말기 거래",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "여러 단말기와 완벽하게 호환되므로 언제든지 다양한 시나리오의 거래 요구를 충족할 수 있습니다.",
  随时查看实时行情: "언제든지 실시간 시장 상황을 확인하세요",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "BTC, ETH, DOGE 및 기타 디지털 자산을 쉽게 구매하고 판매하세요",
  获取您关注的加密货币价格变化预警:
    "관심 있는 암호화폐의 가격 변동에 대한 조기 경고를 받으세요",
  "查看比特币现货、期货、期权价格": "비트코인 현물, 선물, 옵션 가격 보기",
  比较各交易所加密货币价格: "거래소 간 암호화폐 가격 비교",
  开启您的数字货币之旅: "디지털 화폐 여행을 시작하세요",
  快捷购买数字货币: "디지털 화폐를 빠르게 구매하세요",
  "使用多种支付方式交易数字货币，安全快捷":
    "다양한 결제 방법을 사용하여 디지털 통화를 안전하고 빠르게 거래하세요",
  最优的交易费率: "최고의 거래율",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "우대 거래율, 경쟁력 있는 VIP 권리, 최고 품질의 서비스를 누려보세요.",
  可信赖的安全保障: "믿을 수 있는 보안",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "우리의 정교한 보안 조치와 SAFU 자금은 모든 위험으로부터 디지털 자산을 보호합니다.",
  交易: "거래",
  币币市场: "코인시장",
  "24H成交量": "24시간 거래량",
  交易所: "교환",
  "24H最高": "24시간 최고",
  "24H最低": "24시간 최저",
  永续合约: "무기한 계약",
  日涨跌: "일일 상승 및 하락",
  交易深度: "거래 깊이",
  "资产(合约)": "자산(계약)",
  历史仓位: "역사적 위치",
  兑换记录: "교환기록",
  类型: "유형",
  充值记录: "충전기록",
  划转记录: "이체 기록",
  类别: "범주",
  历史账单: "역사적 법안",
  在线充值: "온라인 충전",
  安全设置: "보안 설정",
  用于账户登录使用: "계정 로그인에 사용됩니다",
  用户提现时安全验证使用:
    "이용자가 현금을 인출할 때 보안확인을 위해 사용됩니다.",
  验证: "확인하다",
  万: "만",
  随时随地开启交易: "언제 어디서나 거래를 시작하세요",
  "*货币交易所的所有功能尽在你的手中。":
    "*환전의 모든 기능은 당신의 손에 있습니다.",
  "下载*货币交易所APP。": "다운로드* 환전 앱.",
  下载自: "다음에서 다운로드됨",
  内测版: "내부 베타 버전",
  下载: "다운로드",
  扫码下载: "다운로드하려면 코드를 스캔하세요.",
  设置您的资产密码: "자산 비밀번호 설정",
  法币: "명목화폐",
  我要买: "나는 사고 싶다",
  我要卖: "매도",
  请输入金额: "금액을 입력해주세요.",
  汇率: "환율",
  获得: "힉득",
  支付通道: "결제 채널",
  收款通道: "결제 채널",
  "出售过程需要务必确认好您的收款方式为本人。":
    "판매 과정에서 결제 수단이 본인인지 확인해야 합니다.",
  当前法币暂不支持交易对可尝试前往提现:
    "현재 법정화폐는 거래쌍을 지원하지 않습니다.",
  前往提现: "돈을 인출하러 가세요",
  该法币暂无通道: "현재 이 법정 통화를 사용할 수 있는 채널이 없습니다.",
  "正在出售中，请耐心等待": "현재 판매중이니 조금만 기다려주세요",
  请选择支付通道: "결제채널을 선택해주세요",
  请选择方式: "방법을 선택하세요.",
  法币历史: "법정화폐 역사",
  买币: "동전을 사다",
  卖币: "동전을 팔다",
  失败: "실패하다",
  已完成: "완전한",
  未付款: "미지급",
  待审核: "검토 대기 중",
  打款中: "결제 진행 중",
  订单详情: "주문 세부정보",
  联系客服: "고객 서비스에 문의하세요",
  到账金额: "받은 금액",
  通道: "통로",
  收款人: "수취인",
  收款账户: "추심 계좌",
  "订单出售失败，请查下方失败原因":
    "주문 판매가 실패했습니다. 아래에서 실패 이유를 확인하세요.",
  失败原因: "실패 이유",
  您还未进行付款: "아직 결제하지 않으셨습니다.",
  您已成功购买: "성공적으로 구매하셨습니다",
  已取消订单: "주문이 취소됨",
  "订单正在审核中，请耐心等待": "주문을 검토 중입니다. 잠시만 기다려 주세요.",
  您已成功出售: "성공적으로 판매되었습니다",
  "订单正在打款中，请耐心等待": "주문이 처리 중입니다. 잠시 기다려 주십시오.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "결제 과정에서 결제 주문을 하려면 다른 플랫폼으로 이동해야 합니다. 정보 보안에 주의하시기 바랍니다.",
  当前法币暂不支持交易对可尝试前往充值:
    "현재 법정화폐는 거래쌍을 지원하지 않습니다. 충전을 시도해 보세요.",
  前往充值: "재충전하러 가기",
  购买: "구입하다",
  订单号: "주문 번호",
  单价: "단가",
  到账数量: "도착 수량",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "현재 미결제 주문이 있습니다. 계속해서 새 결제 주문을 시작하시겠습니까?",
  继续支付: "계속해서 결제하세요",
  重新下单: "다시 주문하세요",
  是否确定出售: "확실히 팔까요?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "판매가 확인되면 플랫폼이 구매자에게 할당됩니다. 플랫폼이 일치할 때까지 기다려 주십시오.",
  出售: "매도",
  收款方式: "결제수단",
  订单已生成: "주문이 생성되었습니다",
  取消订单: "주문 취소",
  请在: "제발",
  内完成付款: "이내에 결제를 완료하세요.",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "플랫폼을 떠나 지정된 결제 수단으로 로그인한 후 판매자의 다음 계정으로 이체하고 결제 시 다음 사항을 꼭 참고하세요.",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "결제 시 아무런 언급도 하지 않으면 판매자가 수령을 확인할 수 없어 회복할 수 없는 자산 손실이 발생합니다.",
  "未在规定的时间内付款，订单都将被取消。":
    "규정된 시간 내에 결제가 완료되지 않으면 주문이 취소됩니다.",
  姓名: "이름",
  收款姓名: "수취인 이름",
  开户支行: "계좌 개설 지점",
  银行卡号: "은행 카드 번호",
  "付款后，返回本平台": "결제 후 이 플랫폼으로 돌아오세요",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "아래 '결제 완료, 판매자에게 알림' 버튼을 꼭 눌러주세요.",
  未点击卖家不会放款: "클릭하지 않는 판매자는 돈을 풀어주지 않습니다.",
  交易条款: "거래 조건",
  "购买资金来源，必须合法安全的资金，方可交易":
    "구매 자금의 출처는 거래가 이루어지기 전에 합법적이고 안전한 자금이어야 합니다.",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "사기, 피라미드 계획, 도박 또는 기타 불법 금융 거래는 허용되지 않습니다.",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "거래가 완료된 후 재정적 위험, 동결되거나 사기가 의심되는 자금, 피라미드 계획 또는 도박이 있는 경우 더 이상 구매자에게 자금을 공개하지 않고 환불해 드립니다.",
  "已付款，通知卖家": "지불, 판매자에게 알림",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "구매자가 당일 총 *주문을 취소할 경우 당일구매 기능이 취소됩니다. 정말로 이 주문을 취소하시겠습니까?",
  添加收款方式: "결제 수단 추가",
  是否删除此收款方式: "이 결제 수단을 삭제할지 여부",
  删除: "삭제",
  请选择法币: "법정화폐를 선택해주세요",
  机构名称: "조직 이름",
  请选择机构: "기관을 선택해주세요",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "디지털 화폐를 판매할 때 선택한 결제 방법이 구매자에게 표시됩니다. 올바르게 입력되었는지 확인하세요.",
  请选择银行: "은행을 선택해주세요",
  请输入姓名: "이름을 입력하세요",
  账号: "계정",
  请输入账号: "계좌번호를 입력해주세요",
  收款码: "결제 코드",
  "银行账号/卡号": "은행계좌번호/카드번호",
  "请输入银行账号/卡号": "은행계좌번호/카드번호를 입력해주세요",
  "开户支行（选填）": "계좌개설 지점(선택)",
  请输入开户支行: "계좌가 개설된 지점을 입력해주세요.",
  "加入*官方频道": "Join*공식 채널",
  关于: "~에 대한",
  条款: "자귀",
  成功: "성공",
  等待: "기다리다",
  作废: "무효의",
  确认付款: "결제 확인",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "결제가 완료되었나요? 결제가 확인되면 *분 이내에 가맹점에서 결제가 접수되었는지 확인해드립니다.",
  最大金额: "최대 금액",
  最小金额: "최소 금액",
  付款: "지불",
  法币充值: "법화 충전",
  法币提现: "법정화폐 인출",
  待支付: "지불 예정",
  已支付: "유급의",
  商户名: "판매자 이름",
  当前没有添加支付方式: "현재 추가된 결제 수단이 없습니다.",
  添加后再出售: "판매하기 전에 추가하세요",
  新人大礼包: "초보자 선물 패키지",
  注册即可领取: "그것을 얻으려면 등록하세요",
  立即领取: "지금 받으세요",
  不再提示: "메시지를 다시 표시하지 않음",
  "该奖励需在APP中领取，请下载APP":
    "이 보상은 앱에서 청구해야 합니다. 앱을 다운로드하세요.",
  去交易: "무역하러 가다",
  期权交易: "옵션 거래",
  交易额: "거래량",
  可用额度: "사용 가능한 크레딧",
  交易周期: "거래주기",
  看涨: "상승",
  看跌: "하락",
  当前持有: "현재 개최 중",
  胜率: "승률",
  "盈利/亏损数": "손익 번호",
  累计实现盈亏: "누적실현손익",
  秒: "두번째",
  分: "가리키다",
  小时: "시간",
  周: "주",
  下单时间: "주문시간",
  剩余时间: "남은 시간",
  买入价: "입찰가",
  结算价: "결제 가격",
  实现盈利: "수익성을 달성하다",
  结算时间: "결제 시간",
  期权: "옵션",
  新手教程: "초보자 튜토리얼",
  我的订单: "내 주문",
  赔率: "승산",
  全部订单: "모든 주문",
  持有订单: "주문 보류",
  历史订单: "역사적 명령",
  输入交易额度: "거래 금액 입력",
  选择交易周期: "거래기간 선택",
  去注册: "등록하러 가기",
  冻结: "꼭 매달리게 하다",
  期权支出: "옵션 지급",
  期权收入: "옵션 수입",
  用户提现: "사용자 출금",
  "是否购买？": "사고 싶나요?",
  购买成功: "구매 성공",
  请签名: "서명해주세요",
  提交签名: "서명 제출",
  清空签名: "서명 지우기",
  签名审核中: "검토 중인 서명",
  已提交: "제출된",
  扫一扫下载APP: "스캔하여 앱을 다운로드하세요",
  新手领取大礼包: "초보자는 선물 패키지를받습니다.",
  注册实名即送彩金: "실명으로 등록하고 보너스를 받으세요",
  交易总额: "총 거래 금액",
  资产不足: "자산이 부족함",
  "Win账户的资产不足，可从现货账户划转至此账户":
    "Win 계정에 자산이 부족한 경우 자금 계정에서 이 계정으로 이체할 수 있습니다.",
  Win: "이기다",
  比赛: "경쟁",
  未开始: "시작되지 않음",
  赛程: "일정",
  赛果: "결과",
  已结束: "끝났다",
  让球: "핸디캡",
  进球数: "득점한 골 수",
  大: "큰",
  小: "작은",
  胜负平: "이기든 지든",
  和局: "묶다",
  投注: "내기",
  下注金额: "베팅 금액",
  下注: "베팅하기",
  阵容: "라인업",
  分析: "분석하다",
  输入下注金额: "베팅 금액을 입력하세요",
  下注成功: "성공적인 베팅",
  投注记录: "베팅 기록",
  未结算: "변하기 쉬운",
  已结算: "안정된",
  流水: "흐르는 물",
  输赢: "이기든 지든",
  赛时: "게임 시간",
  下注时间: "베팅 시간",
  足彩竞猜: "축구 베팅",
  查看详情: "세부 사항을 확인하세요",
  输: "잃다",
  赢: "이기다",
  主: "주인",
  客: "고객",
  主胜: "주요 승리",
  客胜: "케성",
  平: "평평한",
  已延期: "연기됨",
  账号异常: "계정 이상",
  全场独赢: "게임에서 승리하세요",
  全场让球: "풀 코트 핸디캡",
  全场大小: "전체 크기",
  总进球: "총 목표",
  拍摄照片要求: "사진 촬영 요구 사항",
  标准拍摄: "표준 촬영",
  边框缺失: "누락된 테두리",
  照片模糊: "사진이 흐릿함",
  闪光强烈: "강한 플래시",
  上传手持证件照: "손에 들고 있는 신분증 사진을 업로드하세요.",
  上传证件照: "신분증 사진 업로드",
  换一张: "하나 변경",
  出生日期: "생일",
  请选择出生日期: "생년월일을 선택해주세요",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "아래에 올바른 그래픽 인증을 입력한 후 이메일 인증 코드를 받아 등록하세요.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "* 인증 횟수가 아직 남아 있습니다. 해당 횟수를 초과할 경우 인증을 계속할 수 없습니다.",
  上半场: "전반",
  下半场: "후반",
  独赢: "혼자서 승리하세요",
  上半场独赢: "전반전 승자",
  下半场独赢: "후반전 승리",
  上半场让球: "전반전 핸디캡",
  下半场让球: "후반전에 공을 줘",
  上半场大小球: "전반전 득점",
  下半场大小球: "후반전 득점",
  波胆: "웨이브 담즙",
  上半场波胆: "용기의 전반파",
  下半场波胆: "하반기 용기의 물결",
  单双: "홀수와 짝수",
  单: "하나",
  双: "쌍",
  上半场单双: "홀수 또는 전반전",
  下半场单双: "홀수든 후반이든",
  上半场总进球: "전반전 총 득점",
  下半场总进球: "후반전 총 득점",
  中场: "미드필더",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "참고: 신분증을 들고 있을 때 이 샘플 사진을 따라 흰색 종이에 텍스트를 쓰고 신분증과 함께 가져가세요.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "최근에는 부정행위 계정이 다수 발견돼 불법 계정이 다수 처벌됐다. 계정이 위반으로 잘못 판단된 경우 온라인 고객 서비스에 문의하세요.",
  最小下注金额: "최소 베팅 금액",
  参与活动最小下注金额: "이벤트 참여를 위한 최소 배팅 금액",
  记住密码: "비밀번호 기억하기",
  比分: "점수",
  "您还未登录，请先登录":
    "아직 로그인하지 않으셨습니다. 먼저 로그인을 해주세요",
  立即登录: "지금 로그인하세요",
  下注限额: "베팅 한도",
  可赢金额: "승리할 금액",
  闪兑详情: "즉시 상환 세부정보",
  大小球: "크고 작은 공",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "환율 문제로 인해 배팅 금액과 실제 배팅 금액에 오차가 발생할 수 있으니 주문을 참고하시기 바랍니다.",
  开赛时间: "킥오프 시간",
  足球收入: "축구 수익",
  足球支出: "축구 지출",
  活动详情: "이벤트 세부정보",
  为世界杯喝彩: "월드컵을 응원합니다",
  我的竞猜: "내 내기",
  "竞猜比赛、有机会瓜分*USDT":
    "경쟁사를 추측하고 *USDT를 공유할 기회를 가지세요",
  "瓜分*USDT": "*USDT 공유",
  距离活动结束还有: "행사 종료까지 아직 시간이 남았습니다",
  我的门票: "내 티켓",
  竞猜结束时间: "베팅 종료 시간",
  猜比分: "점수를 맞춰보세요",
  "福利派送中，完成任务即可获取门票":
    "복지가 배부되고 있습니다. 티켓을 받으려면 작업을 완료하세요.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "대회에 참가할 수 있는 티켓 수를 얻으려면 다음 작업을 완료하세요.",
  时: "시간",
  活动: "활동",
  竞猜记录: "베팅 기록",
  结果: "결과",
  任务: "일",
  去邀请: "초대하다",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "각 게임의 점수에 베팅하고, 베팅에 참여하면 $* USD 보상을 공유할 수 있습니다.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "대회에 참가하려면 티켓이 필요하며, 플랫폼의 업무에 따라 티켓을 획득할 수 있습니다.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的现货账户，你可以立即提取。":
    "퀴즈에 성공한 후, 퀴즈 결과의 캡쳐를 고객센터에 보내면, 고객센터는 상금을 당신의 자금 계좌에 입금할 것이며, 당신은 즉시 인출할 수 있습니다.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "부정 행위가 발견되면 보상이 무효화됩니다.",
  "完成任务后，点击咨询客服获得门票。":
    "작업을 완료한 후 클릭하여 고객 서비스에 문의하여 티켓을 받으세요.",
  继续猜: "계속 추측해 보세요",
  总单数: "총 홀수",
  赛事筛选: "이벤트 상영",
  球队筛选: "팀 필터",
  总金额: "일시금",
  总流水: "총 매출액",
  派奖金额: "상금 금액",
  下注单数: "홀수 베팅",
  利润: "이익",
  更多福利: "더 많은 혜택",
  我的奖金: "내 보너스",
  未认证: "인증되지 않음",
  总量: "총액",
  或: "또는",
  模拟交易: "모의거래",
  体验账户不可操作: "평가판 계정을 사용할 수 없습니다",
  世界杯比分竞猜: "월드컵 점수 베팅",
  "领*USDT起": "*USDT에서 받기",
  消息: "정보",
  滚球: "롤링 볼",
  是: "예",
  不是: "아니요",
  当前余额: "현재 잔액",
  KOL招募: "KOL 모집",
  本月净输赢: "이번 달 순승 또는 손실",
  本月佣金: "이번달 커미션",
  佣金比例: "수수료 비율",
  活跃人数: "활동적인 사람의 수",
  新增下级: "부하 직원 추가",
  登录人数: "로그인한 사람 수",
  首存人数: "최초 예금자 수",
  数据分析: "데이터 분석",
  人数: "인원수",
  新注册存款金额: "신규등록 보증금 금액",
  老用户存款金额: "기존 사용자 예치 금액",
  首存金额: "첫 입금액",
  快捷入口: "빠른 입력",
  成员管理: "회원관리",
  财务报表: "재무제표",
  分红报表: "배당보고서",
  订单记录: "주문기록",
  VIP专享: "VIP 전용",
  推广工具: "홍보 도구",
  计算规则: "계산 규칙",
  账变明细: "계정 변경 세부정보",
  成员: "회원",
  下级概览: "하위 수준 개요",
  下级成员总计: "총 하위 구성원",
  本月新增: "이번 달 새로운",
  本月活跃会员: "이번 달 활동 회원",
  今日活跃会员: "오늘 활동하는 회원",
  本月有效活跃: "이번 달에 효과적으로 활성화됨",
  活跃成员占比: "활동 회원 비율",
  本月活跃: "이번달 활성",
  今日活跃: "오늘 활동 중",
  下级成员: "주니어 멤버",
  会员账号: "회원 계정",
  统计时间: "통계시간",
  筛选: "필터",
  存款: "보증금",
  取款: "돈을 인출하다",
  总输赢: "총 승패",
  是否有效用户: "유효한 사용자입니까?",
  最近登录时间: "마지막 로그인 시간",
  否: "아니요",
  开始时间: "시작 시간",
  结束时间: "종료 시간",
  提取: "발췌",
  总盈亏: "총손익",
  净盈亏: "순이익과 손실",
  分红: "피제수",
  概览: "개요",
  月度详细数据: "월간 상세 데이터",
  未发放: "발급되지 않음",
  活跃用户: "활성 사용자",
  有效新增会员: "효과적으로 새 회원 추가",
  冲正后净输赢: "정정 후 순승 또는 손실",
  上月结余: "지난달 잔액",
  净输赢: "순승 또는 패",
  "系统每日新加坡时间1:00更新一次报表":
    "시스템은 매일 싱가포르 시간 1시에 보고서를 업데이트합니다.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "데이터, 보고서의 총 승패, 순 승패에서 양수는 에이전트의 이익을 나타내고 음수는 에이전트의 손실을 나타냅니다.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "수수료 데이터는 매일 업데이트되며 참고용일 뿐 실제 수수료 배분 기준이 되는 것은 아닙니다.",
  选择时间: "시간 선택",
  足球: "축구",
  投注金额: "베팅 금액",
  有效订单: "유효한 주문",
  下级账户: "하위 계정",
  待成交: "보류 중인 거래",
  下单金额: "주문 금액",
  订单内容: "주문 내용",
  秒数: "초 수",
  联赛: "리그",
  队伍: "팀",
  比赛时间: "게임 시간",
  玩法: "플레이 방법",
  等级规则表: "레벨 규칙 표",
  等级: "등급",
  活跃会员: "활동 회원",
  最新活跃: "최신 활성",
  额外佣金: "추가 수수료",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "해당 레벨의 성장 기준과 보상 시스템은 매달 시행되며, 한 레벨의 보상만 누릴 수 있습니다.",
  渠道生成: "채널 생성",
  创建: "만들다",
  渠道名称: "채널 이름",
  注册人数: "등록인원",
  浏览人数: "방문객 수",
  构建状态: "빌드 상태",
  禁用: "장애를 입히다",
  启用: "~할 수 있게 하다",
  查看: "확인하다",
  创建渠道: "채널 만들기",
  创建成功: "성공적으로 생성되었습니다",
  操作成功: "작업 성공",
  渠道详情: "채널 세부정보",
  邀请码: "초대코드",
  访问人数: "방문객 수",
  渠道地址: "채널 주소",
  我的福利: "내 혜택",
  充值福利: "재충전 혜택",
  当前流水: "현재 매출액",
  如何参与: "참여 방법",
  币种充值: "통화 충전",
  充值福利中领取福利: "충전혜택을 받아보세요",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "규정: 충전 혜택은 자발적으로 적립되며, 유효기간은 충전 후 24시간 이내이며, 적립 후 출금 기능은 일시적으로 잠깁니다.",
  失效日期: "만료일",
  "暂无福利领取，充值后领取":
    "현재 제공되는 혜택은 없으며, 충전 후 받으실 수 있습니다.",
  参与: "참가하다",
  充值赠送: "선물충전",
  "领取*%的赠送": "*% 보너스 받기",
  去领取: "가서 얻으세요",
  VIP奖励: "VIP 보상",
  "当前可领取*USDT，是否确认领取":
    "*USDT는 현재 수집 가능합니다. 수집을 확인하시겠습니까?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "출금 기능은 수령 후 일시적으로 잠기며, 매출액이 *USDT에 도달하면 잠금 해제됩니다.",
  充值送大礼: "충전하고 푸짐한 선물 받아가세요",
  "存入越多，送越多！": "더 많이 입금할수록 더 많은 것을 얻을 수 있습니다!",
  无效: "유효하지 않은",
  有效: "효율적인",
  总存金额: "총 입금액",
  提示: "힌트",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "총 승패 및 순승패의 양수는 플랫폼 수익을 나타내고, 음수는 손실을 나타냅니다. 일일 데이터는 참고용일 뿐 실제 커미션 배분 기준으로 사용되지 않습니다.",
  "净盈亏：总盈亏-用户返水":
    "순이익 및 손실: 총 이익 및 손실 - 사용자 리베이트",
  盈利方: "이익 측면",
  代理: "연기",
  客户: "고객",
  平局: "그리다",
  平台: "플랫폼",
  "已提交审核，请耐心等待": "검토를 위해 제출되었습니다. 잠시 기다려 주십시오.",
  充值日期: "재충전 날짜",
  平台本月总输赢: "이번 달 플랫폼의 총 승패",
  KOL招募合作: "KOL 채용 협력",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "이제 [KOL 채용활동] 플랫폼이 오픈되었습니다. 소셜미디어 계정만 있으면 고객을 위한 일회성 프로모션 플랫폼으로 배당을 누릴 수 있으며, 평생 혜택을 누릴 수 있습니다.",
  级别: "수준",
  平台利润返佣: "플랫폼 수익 리베이트",
  佣金案例: "수수료 사건",
  交易项目: "거래항목",
  "期权交易、合约交易、足球游戏": "옵션 거래, 계약 거래, 축구 경기",
  报名方式: "등록방법",
  点击KOL招募报名: "KOL 채용 신청을 클릭하세요",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "우리 팀에 오신 것을 환영합니다. 플랫폼은 귀하가 자신의 사용자 시스템을 구축할 수 있도록 완벽하게 지원하며 귀하의 합류를 기대합니다.",
  输入联系方式: "연락처 정보를 입력하세요",
  最低活跃人数: "최소 활동 인원 수",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "예를 들어, 이번 달 활성 사용자 수는 ≥*이고 이번 달 플랫폼의 총 승패는 ≥*USDT입니다. * 레벨에 속하면 *% 커미션을 받을 수 있습니다.",
  比分竞猜: "점수 베팅",
  豪礼相赠: "선물",
  足球活动: "축구 활동",
  圣诞节活动: "크리스마스 활동",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "이벤트에 참여하셨으며 출금 기능이 일시적으로 잠겨 있습니다. 잠금 해제를 위해서는 *USDT 전송이 필요합니다.",
  剩余流水: "남은 매출액",
  助力足球: "축구를 도와주세요",
  佣金累计: "커미션 적립",
  有效投注: "유효한 베팅",
  今日: "오늘",
  今日返水: "오늘 반수",
  VIP返水: "VIP 리베이트",
  返水记录: "캐시백 기록",
  成员信息: "회원정보",
  基本信息: "기본정보",
  钱包余额: "지갑 잔액",
  投注信息: "베팅정보",
  返水: "할인",
  总下注: "총 베팅",
  今日输赢: "오늘의 승패",
  下注动态: "베팅 업데이트",
  返水奖励: "리베이트 보상",
  分红金额: "배당금액",
  返水支出: "리베이트 지급",
  总返水: "총 리베이트",
  流水总额: "총 매출액",
  返水总额: "총 리베이트 금액",
  返水详情: "리베이트 세부정보",
  日流水: "매일 흐르는 물",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "플랫폼은 부하직원의 일일 매출액을 기준으로 추가 리베이트 보상을 제공하며, 보상은 싱가포르 시간으로 매일 00:00에 바운티 계정에 배포됩니다.",
  "申请成功，等待审核": "신청이 완료되었으며 검토를 기다리는 중입니다.",
  "我出本金，盈利共分享": "원금을 기부하고 수익을 공유합니다",
  最高分红: "최고 배당금",
  投资大师比赛: "투자 마스터 대회",
  "我出本金，你盈利": "나는 원금을 지불하고 당신은 이익을 얻습니다",
  共分享: "공유됨",
  最高分红可得: "최대 배당 가능",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "신규 사용자를 위한 독점 혜택이 제공됩니다. $*를 무료로 받으시면 플랫폼의 모든 프로젝트에 투자하실 수 있으며, 수익을 낸 후 즉시 출금하실 수 있습니다.",
  报名领取: "수신하려면 가입하세요",
  审核驳回: "리뷰가 거부됨",
  驳回原因: "거부 이유",
  活动运行周期: "활동 실행 주기",
  "申请成功后起至*天内完成超额收益。":
    "초과소득은 신청 성공 후 *일 이내에 완료됩니다.",
  分红比: "배당비율",
  "*日获得盈利后，可获得*%的收益额。":
    "*일에 수익을 낸 후, 수익금액의 *%를 받으실 수 있습니다.",
  参与条件: "참여 조건",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "러시아와 터키 사용자는 참여하지 않았습니다.",
  计算项目: "계산 프로젝트",
  "合约、体育、期权": "계약, 스포츠, 옵션",
  我的投资: "나의 투자",
  参与天数: "참가일",
  累计下注: "누적 베팅",
  累计盈亏: "누적 손익",
  预计可分红: "예상 배당금",
  常见问题: "FAQ",
  什么是平台出资: "플랫폼 투자란 무엇인가",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "이 플랫폼은 사용자가 일부 국가의 사용자를 기반으로 하는 프로젝트에 투자할 수 있는 무료 자금을 제공합니다.",
  怎么获取平台出资的福利: "플랫폼 투자의 혜택을 얻는 방법",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "지정된 국가의 사용자만 있으면 됩니다. 플랫폼 검토가 완료되면 *USDT가 현재 계정의 바운티 계정으로 이체되어 투자할 수 있습니다.",
  什么是分红: "배당금이란 무엇입니까?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "배당이란 일정 기간 내에 소득이 100%에 도달한 후 초과 소득의 50%를 분할할 수 있는 것을 의미합니다. 예를 들어, 100 USDT 자금을 받으려면 수입 금액이 120%입니다.",
  "如何取得分红？": "배당금을 받는 방법은 무엇입니까?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "활동 주기는 *일 1회입니다. 활동이 완료된 후 계산이 수행되며, 활동 요구 사항이 충족되면 배당금이 포상금 계정에 분배됩니다. 활동 요구 사항을 충족하지 못하는 경우 시스템은 자동으로 귀하의 수입과 플랫폼 투자를 정산합니다.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "참여 계정은 KYC 인증을 받아야 하며, 각 계정은 하나의 혜택으로 제한됩니다.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "참여 계정의 KYC에는 지정된 국가가 참여해야 합니다. 다른 지역에서는 참여가 승인되지 않습니다. 활성 국가가 귀하의 국가와 일치하는지 확인하세요.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "활동에 성공적으로 참여한 후 귀하의 계정은 일시적으로 출금 기능을 잠그고 활동이 완료된 후 출금 기능이 해제됩니다.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "플랫폼 활동 규칙을 준수하십시오. 이익을 얻기 위해 부정 행위를 하거나 시스템 취약점을 이용하는 것으로 밝혀지면 플랫폼은 오랫동안 귀하의 계정에 있는 모든 자금을 동결시킵니다.",
  平台出资: "플랫폼 투자",
  平台出资收回: "플랫폼 투자 회복",
  投资大师奖励: "투자 마스터 보상",
  请下载APP添加收款方式: "결제 수단을 추가하려면 앱을 다운로드하세요.",
  请下载APP进行身份验证: "신원 확인을 위해 앱을 다운로드하세요.",
  请下载APP参与: "참여하려면 APP을 다운로드하세요.",
  技术指标: "기술 지표",
  主图: "메인 사진",
  副图: "하위 사진",
  新注册人数: "신규등록 건수",
  老用户存款人数: "기존 사용자의 예금자 수",
  存款人数: "예금자 수",
  取款人数: "인출 횟수",
  投注人数: "베터 수",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "참여하지 않은 인도네시아, 인도, 방글라데시를 제외한 사용자.",
  市场动态: "시장 역학",
  外汇合约: "외환 계약",
  盈亏比: "손익 비율",
  委托价: "주문 가격",
  可用余额: "사용 가능한 잔액",
  持仓额: "포지션 금액",
  强平价: "강력한 패리티",
  修改: "개정하다",
  修改价位: "가격 수정",
  外汇: "외환",
  外汇账户: "외환 계좌",
  我的交易: "내 거래",
  未设置: "설정되지 않음",
  超出最大可设数值: "최대 설정값을 초과했습니다.",
  超出最小可设数值: "최소 설정값을 초과함",
  止盈超出最小可设数值: "이익 실현이 최소 설정 값을 초과합니다.",
  止损超出最大可设数值: "정지 손실이 최대 설정 값을 초과합니다.",
  止盈超出最大可设数值: "이익실현이 최대 설정 값을 초과했습니다.",
  止损超出最小可设数值: "정지 손실이 최소 설정 값을 초과합니다.",
  挖矿: "채광",
  交易账户: "거래계좌",
  买涨: "구매",
  买跌: "구매 또는 판매",
  请输入正确的银行卡信息: "올바른 은행 카드 정보를 입력하세요.",
  联系在线客服: "온라인 고객 서비스에 문의하세요",
  法币交易请联系在线客服:
    "합법적인 화폐 거래를 위해서는 온라인 고객센터에 문의하세요.",
  提交订单: "주문 제출",
  "支付过程如有疑问,请联系在线客服":
    "결제 과정에 대해 궁금한 점이 있으면 온라인 고객 서비스에 문의하세요.",
  彩金赠送: "보너스 보너스",
  在线客服: "온라인 고객 서비스",
  最少投资: "최소 투자",
  "提交时间:": "제출 시간:",
  提现拒绝: "출금이 거부됨",
  认证拒绝: "인증이 거부됨",
  认证通过: "인증 통과",
  请输入正确的交易额度: "정확한 거래금액을 입력해주세요",
  最大下注金额: "최대 베팅 금액",
  手机号: "전화 번호",
  邮箱注册: "이메일 등록",
  手机号注册: "휴대폰번호 등록",
  查询: "질문",
  手机号登录: "휴대폰번호 로그인",
  邮箱登录: "이메일 로그인",
  请输入数量: "수량을 입력해주세요",
  可用数量: "사용 가능 수량",
  钱包登录: "지갑 로그인",
  请输入正确的邀请码: "올바른 초대코드를 입력해주세요",
  "请输入邀请码(必填)": "초대코드를 입력해주세요 (필수)",
  输入正确的金额: "정확한 금액을 입력하세요.",
  卢比充值: "루피 충전",
  请输入法币: "법정 통화를 입력하세요.",
  请输入IFSC: "IFSC를 입력하세요.",
  "银行编码(选填)": "은행 코드(선택사항)",
  请输入银行编码: "은행코드를 입력해주세요",
  请输入大于8位数的密码: "8자리 이상의 비밀번호를 입력해주세요",
  添加成功: "성공적으로 추가되었습니다",
  "60秒": "60초",
  "180秒": "180초",
  "300秒": "300초",
  "2次密码不一致": "2개의 비밀번호가 일치하지 않습니다.",
  输入提币数量: "출금금액을 입력하세요",
  图片格式不正确: "이미지 형식이 잘못되었습니다.",
  图片大于20M: "20M보다 큰 사진",
  请设置委托价格: "주문가격을 설정해 주세요",
  输入资金密码: "펀드 비밀번호를 입력하세요",
  验证码错误: "인증코드 오류",
  充值拒绝: "재충전이 거부됨",
  请输入SSN: "SSN을 입력해주세요",
  合约交易: "계약 거래",
  结算完成: "결제 완료",
  继续下单: "주문 계속하기",
  最低购买: "최소 구매",
  最高购买: "최고 구매",
  限价: "한도 가격",
  买入价格: "매수 가격",
  买入量: "매수 수량",
  卖出价格: "매도 가격",
  卖出量: "매도 수량",
  买入: "매수",
  卖出: "매도",
  订单创建成功: "주문이 성공적으로 생성되었습니다",
  币币买入支出: "암호화폐 매수 지출",
  币币买入支出退还: "암호화폐 매수 지출 환불",
  币币买入获得: "암호화폐 매수로 얻은 것",
  币币卖出支出: "암호화폐 매도 지출",
  币币卖出支出退还: "암호화폐 매도 지출 환불",
  币币卖出获得: "암호화폐 매도로 얻은 것",
  币币交易手续费: "암호화폐 거래 수수료",
  请输入限价: "한도 가격을 입력하세요",
  成交: "완료",
  等待成交: "완료 대기 중",
  交易完成: "거래가 완료되었습니다",
  被取消: "취소되었습니다",
  交易时间: "거래 시간",

  法币交易: "법정 화폐 거래",
  法币出售: "법정 화폐 판매",
  两次密码不一致: "두 비밀번호가 일치하지 않습니다",
  再次输入账户密码: "계정 비밀번호를 다시 입력하세요",

  美国: "미국",
  韩国: "대한민국",
  阿尔巴尼亚: "알바니아",
  津巴布韦: "짐바브웨",
  赞比亚: "잠비아",
  也门: "예멘 아랍 공화국",
  美属维尔京群岛: "미국 버진 아일랜드",
  英属处女群岛: "영국령 버진 아일랜드",
  越南: "베트남",
  委内瑞拉: "베네수엘라",
  瓦努阿图: "바누아투",
  乌兹别克斯坦: "우즈베키스탄",
  乌拉圭: "우루과이",
  英国: "영국",
  阿拉伯联合酋长国: "아랍 에미리트 연합",
  乌克兰: "우크라이나",
  乌干达: "우간다",
  特克斯和凯科斯群岛: "터키와 카이코스 제도",
  土库曼斯坦: "투르크 메니스탄",
  土耳其: "Türkiye",
  突尼斯: "튀니지",
  特立尼达和多巴哥: "트리니다드 토바고",
  汤加: "통가",
  多哥: "토고",
  东帝汶: "동 티모르",
  泰国: "태국",
  坦桑尼亚: "탄자니아",
  塔吉克斯坦: "타지키스탄",
  中国台湾: "대만, 중국",
  叙利亚: "시리아",
  瑞士: "스위스",
  瑞典: "스웨덴",
  斯威士兰: "스와질란드",
  苏里南: "수리남",
  苏丹: "수단",
  斯里兰卡: "스리랑카",
  西班牙: "스페인",
  南非: "남아프리카",
  索马里: "소말리아",
  所罗门群岛: "솔로몬 제도",
  斯洛文尼亚: "슬로베니아",
  斯洛伐克: "슬로바키아",
  "圣马丁岛（荷兰部分）": "세인트 마틴 (네덜란드 부분)",
  新加坡: "싱가포르",
  塞拉利昂: "시에라 리온",
  塞舌尔: "세이셸",
  塞尔维亚: "세르비아",
  塞内加尔: "세네갈",
  沙特阿拉伯: "사우디 아라비아",
  圣多美和普林西比: "Sao Tome과 Principe",
  圣马力诺: "산 마리노",
  萨摩亚: "사모아",
  圣克里斯托弗和尼维斯: "세인트 크리스토퍼와 네비스",
  圣文森特和格林纳丁斯: "세인트 빈센트와 그레나딘",
  圣彼埃尔和密克隆岛: "세인트 피에르와 미 킬론 섬",
  圣露西亚: "세인트 루시아",
  圣基茨和尼维斯: "세인트 키츠와 네비스",
  卢旺达: "르완다",
  俄罗斯: "러시아 제국",
  罗马尼亚: "루마니아",
  留尼汪: "재결합",
  刚果共和国: "콩고 공화국",
  卡塔尔: "카타르",
  波多黎各: "푸에르토 리코",
  葡萄牙: "포르투갈",
  波兰: "폴란드",
  菲律宾: "필리핀",
  秘鲁: "페루",
  巴拉圭: "파라과이",
  巴布亚新几内亚: "파푸아 뉴기니",
  巴拿马: "파나마",
  巴勒斯坦: "팔레스타인",
  帕劳: "팔라우",
  巴基斯坦: "파키스탄",
  阿曼: "오만",
  挪威: "노르웨이",
  尼日利亚: "나이지리아",
  尼日尔: "니제르",
  尼加拉瓜: "니카라과",
  新西兰: "뉴질랜드",
  新喀里多尼亚: "뉴 칼레도니아",
  荷属安德列斯群岛: "네덜란드 안드레스 제도",
  荷兰: "네덜란드",
  尼泊尔: "네팔",
  纳米比亚: "나미비아",
  缅甸: "미얀마",
  莫桑比克: "모잠비크",
  摩洛哥: "모로코 가죽",
  蒙特塞拉特岛: "Montserrat Island",
  黑山: "몬테네그로",
  蒙古: "몽골리아",
  摩纳哥: "모나코",
  摩尔多瓦: "몰도바",
  墨西哥: "멕시코",
  马约特: "Mayot",
  毛里求斯: "모리셔스",
  毛里塔尼亚: "모리타니",
  马里亚纳群岛: "마리아나 제도",
  马提尼克: "마르티니크",
  马耳他: "몰타",
  马里: "말리",
  马尔代夫: "몰디브",
  马来西亚: "말레이시아",
  马拉维: "말라위",
  马达加斯加: "마다가스카르",
  马其顿: "마케도니아",
  中国澳门: "마카오, 중국",
  卢森堡: "룩셈부르크",
  立陶宛: "리투아니아",
  列支敦士登: "리히텐슈타인",
  利比亚: "리비아",
  利比里亚: "라이베리아",
  莱索托: "레소토",
  黎巴嫩: "레바논",
  拉脱维亚: "라트비아",
  老挝: "라오스",
  吉尔吉斯斯坦: "키르기스스탄",
  科威特: "쿠웨이트",
  基里巴斯: "키리 바티",
  肯尼亚: "케냐",
  哈萨克斯坦: "카자흐스탄",
  约旦: "요르단",
  日本: "일본",
  牙买加: "자메이카",
  象牙海岸: "상아 해안",
  意大利: "이탈리아",
  以色列: "이스라엘",
  爱尔兰: "아일랜드",
  伊拉克: "이라크",
  伊朗: "이란",
  印度尼西亚: "인도네시아 공화국",
  印度: "인도",
  冰岛: "아이슬란드",
  匈牙利: "헝가리",
  中国香港: "홍콩, 중국",
  洪都拉斯: "온두라스",
  海地: "아이티",
  圭亚那: "가이아나",
  几内亚比绍共和国: "기니 비시 공화국",
  几内亚: "기니",
  危地马拉: "과테말라",
  关岛: "괌",
  瓜德罗普岛: "과드루프",
  格林纳达: "그렌다",
  格陵兰岛: "그린란드",
  希腊: "그리스",
  直布罗陀: "지브롤터",
  加纳: "가나",
  德国: "독일",
  格鲁吉亚: "그루지야",
  冈比亚: "감비아",
  加蓬: "가봉",
  法属波利尼西亚: "프랑스 폴리네시아",
  法属圭亚那: "프랑스 기아나",
  法国: "프랑스",
  芬兰: "핀란드",
  斐济: "피지",
  法罗群岛: "Faroe Islands",
  埃塞俄比亚: "에티오피아",
  爱沙尼亚: "에스토니아",
  厄立特里亚: "에리트레아",
  赤道几内亚: "적도 기니",
  萨尔瓦多: "엘살바도르",
  埃及: "이집트",
  厄瓜多尔: "에콰도르",
  多米尼加共和国: "도미니카 공화국",
  多米尼加: "도미니카",
  吉布提: "지부티",
  丹麦: "덴마크",
  捷克: "체코 공화국",
  塞浦路斯: "키프로스",
  库拉索: "Curacao",
  古巴: "쿠바",
  克罗地亚: "크로아티아",
  哥斯达黎加: "코스타리카",
  科特迪瓦: "코트 디부 아르",
  库克群岛: "쿡 제도",
  科摩罗: "코 모로",
  哥伦比亚: "콜롬비아",
  智利: "칠레",
  乍得: "차드",
  中非共和国: "중앙 아프리카 공화국",
  佛得角: "케이프 베르데",
  开曼群岛: "케이맨 제도",
  开普: "카이푸",
  加拿大: "캐나다",
  喀麦隆: "카메룬",
  柬埔寨: "캄보디아",
  布隆迪: "부룬디",
  布基纳法索: "부르 키나 파소",
  保加利亚: "불가리아",
  文莱: "브루나이",
  巴西: "브라질",
  博茨瓦纳: "보츠와나",
  波斯尼亚和黑塞哥维那: "보스니아와 헤르체고비나",
  玻利维亚: "볼리비아",
  不丹: "부탄",
  百慕大群岛: "버뮤다 섬들",
  贝宁: "베닌",
  伯利兹: "벨리즈",
  比利时: "벨기에",
  白俄罗斯: "벨라루스",
  巴巴多斯: "바베이도스",
  孟加拉国: "방글라데시",
  巴林: "바레인",
  巴哈马: "바하마",
  阿塞拜疆: "아제르바이잔",
  奥地利: "오스트리아",
  澳大利亚: "호주",
  阿鲁巴: "아루바",
  亚美尼亚: "아르메니아",
  阿根廷: "아르헨티나",
  安提瓜和巴布达: "안티구아와 바부 다",
  安圭拉: "앵 guilla",
  安哥拉: "앙골라",
  安道尔: "안도라",
  美属萨摩亚: "미국 사모아",
  阿尔及利亚: "알제리",
  中国: "중국",

  日收益: "일일 수익",
  "30天预期收益": "30일 예상 수익",
  英伟达高速矿机: "NVIDIA 고속 마이닝 기계",
  去投资: "투자하러 가기",
  新币榜: "신규 코인 랭킹",
  主题: "주제",
  立即探索: "즉시 탐색",
  等您来: "기다리고 있습니다",
  最新活动: "최신 행사",
  货币划转: "화폐 이체",
  提现钱包: "출금 지갑",
  加密合约: "암호화 계약",
  外汇期货: "외환 선물",
  定期: "정기 예금",
  探索产品: "상품 탐색",
  稳健型: "안정형",
  高收益: "고수익",
  期货账户: "선물 계좌",
  时间线: "타임라인",
  收藏: "즐겨찾기",
  委托订单: "위탁 주문",
  最新交易: "최신 거래",
  深度图: "깊이 차트",
  标记价格: "마크 가격",
  "24h最高价": "24시간 최고가",
  "24h成交量": "24시간 거래량",
  "24h最低价": "24시간 최저가",
  "24h成交额": "24시간 거래 금액",
  "价格(USDT)": "가격 (USDT)",
  "数量(ETH)": "수량 (ETH)",
  看空: "공매도",
  余额不足: "잔액 부족",
  最低购买: "최소 구매 금액",
  最高购买: "최대 구매 금액",
  下单成功: "주문 성공",
  平仓成功: "포지션 청산 성공",
  请输入正确的平仓数量: "정확한 청산 수량을 입력해주세요",
  加仓成功: "포지션 증량 성공",
  请输入正确的加仓金额: "정확한 증량 금액을 입력해주세요",
  收藏成功: "즐겨찾기 추가 성공",
  取消收藏成功: "즐겨찾기 취소 성공",
  日收益率: "일일 수익률",
  轻松理财: "쉬운 자산 관리",
  立即申购: "즉시 신청 구매",
  申购日期: "신청 구매 일자",
  加密货币: "암호화폐",
  交割合约: "물품 납품 계약",
  最小投资: "최소 투자 금액",
  委托: "위탁",
  "当指数价格触达时，将会触发委托平仓":
    "지수 가격에 도달하면 위탁 청산이 트리거됩니다",
  预计盈利: "예상 수익",
  最大投资: "최대 투자 금액",
  现货交易: "암호화폐 거래",
  输入交易金额: "거래 금액을 입력해주세요",
  "可用额度：": "사용 가능 한도:",
  提现货币: "출금 화폐",
  期货合约: "선물 계약",
  加密币永续: "암호화폐 무기한",
  外汇永续: "외환 무기한",
  期权账户: "옵션 계정",
  夜间模式: "야간 모드",
  未结盈亏: "미실현 이익 및 손실",
  超额收益: "초과 이익",
  "安全策略，低买高卖": "보안 전략, 낮은 가격에 높은 가격으로 구입",
  投资金额应为: "투자 금액은",
  总收益率: "총수익률",
  赎回成功: "환매 성공",
  快捷卖币: "빠른 판매",
  修改止盈止损: "TP/SL 수정",
  白皮书: "백",
  托管资金: "운용 자금",
  托管中: "운용 중",
  预计日收益: "예상 일일 수익",
  累计收益: "누적 수익",
  周期: "기간",
  日收益: "일일 수익",
  限额: "한도",
  立即托管: "지금 운용하기",
  "已鎖定 請聯繫客服": "잠금 상태입니다. 고객센터에 문의해 주세요",
  产品列表: "상품 목록",
  规则: "규칙",
  创建订单: "주문 생성",
  产品名称: "상품명",
  托管周期: "운용 기간",
  等级限制: "등급 제한",
  托管金额: "운용 금액",
  限额: "한도",
  余额: "잔액",
  购买日: "구매일",
  起息日: "이자 시작일",
  派息时间: "배당 시간",
  每天: "매일",
  计息结束日: "이자 종료일",
  每日收益: "일일 수익",
  预计收益: "예상 수익",
  "收益将自动发送至您的余额账户;": "수익은 자동으로 잔액 계좌로 전송됩니다;",
  "您的资金没有任何风险;": "자금에는 어떠한 위험도 없습니다;",
  "365*24小时不断地工作;": "365일 24시간 지속적으로 운영됩니다;",
  托管中: "운용 중",
  结束: "종료",
  今日收益: "오늘 수익",
  剩余周期: "남은 기간",
  进行中: "진행 중",
  已发放: "지급 완료",
  信誉分: "평판 포인트",

  复制成功: "복사 성공",
  VIP权益: "VIP 혜택",
  旧密码: "기존 비밀번호",
  请输入旧密码: "기존 비밀번호를 입력하세요",
  "忘记旧密码请联系客服重置。":
    "기존 비밀번호를 잊으셨다면 고객센터에 문의하시어 재설정하시기 바랍니다.",
  去升级: "업그레이드",
  描述: "설명",
  实际存款金额: "실제 입금액",
  升级礼金: "업그레이드 보너스",
  隔夜利息: "스왑 포인트",
  自动结算: "자동 정산",
  等级规则: "등급 규칙",
  "WEB3.0币持有数据收益": "WEB3.0 코인 보유 데이터 수익률",
  总生产: "총 생산량",
  有效节点: "유효 노드",
  参与人: "참여자",
  用户收益: "사용자 수익률",
  "流动性WEB3.0输出": "유동성 WEB3.0 출력",
  总资产: "총 자산",

  ETHAI持有数据收益: "ETHAI 보유 데이터 수익률",
  AI量化流动性: "AI 양적 유동성",
  现货买入手续费: "현물 매입 수수료",
  现货支出: "현물 지출",
  现货资金费率: "현물 자금 조달 비율",
  现货卖出手续费: "현물 매도 수수료",
  现货收入: "현물 수입",
  外汇合约支出: "외환 계약 지출",
  外汇合约买入手续费: "외환 계약 매입 수수료",
  外汇合约资金费率: "외환 계약 자금 조달 비율",
  外汇合约卖出手续费: "외환 계약 매도 수수료",
  外汇合约收入: "외환 계약 수입",
  理财购买: "자산 관리 구매",
  VIP理财日收益: "VIP 자산 관리 일일 수익률",
  VIP理财隔夜利息: "VIP 자산 관리 오버나이트 이자",
  VIP本金返还: "VIP 원금 반환",
  VIP彩金发放: "VIP 보너스 지급",
  VIP彩金抵扣: "VIP 보너스 차감",
  隔夜利息: "오버나이트 이자",
  设置资产密码: "자산 비밀번호 설정",

  锁仓挖矿: "락업 마이닝",
  一站式理财服务: "원스톱 자산관리 서비스",
  产品: "상품",
  客服中心: "고객센터",
  贷款: "대출",
  挖矿赚不停: "마이닝으로 지속 수익",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "락업 마이닝은 USDT (USD:1USDT=1USD)를 플랫폼의 초고성능 마이닝 장비에 예치하여 플랫폼 마이닝 풀에서 수익을 얻는 방식입니다.",
  产品优势: "상품 장점",
  随存随取: "수시 입출금",
  锁仓周期: "락업 기간",
  每日下发: "일일 지급",
  随机空投: "랜덤 에어드랍",
  "100%资金安全保障": "100% 자금 안전 보장",
  "100%节假日收益不间断": "휴일에도 100% 수익 지속",
  成功锁仓后当天产出: "락업 성공 당일부터 수익 발생",
  关于违约金: "위약금 안내",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "만기 전에 원금을 인출할 경우 위약금이 발생합니다. 위약금 = 위약 정산 비율 × 잔여 일수 × 락업 금액.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "예시: 해당 락업 마이닝의 위약 정산 비율은 5%이며, 잔여 기간은 3일, 락업 금액은 10000U(USDT/USD)입니다. 위약금 = 5%×3×10000=1500U, 실제 반환 원금은 15000U-1500U입니다.",
  收益计算: "수익 계산",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "플랫폼에는 다양한 락업 마이닝 금융 상품이 있으며, 수익 계산은 다음과 같습니다. 예시:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "회원이 플랫폼에서 10000U(USDT, USD)를 락업하고 7일 기간의 일일 수익률 0.7%~1.8% 상품을 선택한 경우, 일일 수익은 다음과 같습니다:",
  "最低:10000Ux0.7%=70U;": "최소: 10000U×0.7%=70U;",
  "最高:10000Ux1.8%=180U;": "최대: 10000U×1.8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "7일 후 490U~1260U의 수익을 받을 수 있으며, 수익은 매일 지급되고 만기 시 원금은 자동으로 자금 계좌로 이체됩니다.",
  正在托管的资金: "관리 중인 자금",
  签到: "출석 체크",
  锁仓订单: "락업 주문",
  预计今日收益: "오늘 예상 수익",
  累计收益: "누적 수익",
  托管中的订单: "관리 중인 주문",
  单笔最少: "최소 주문 금액",
  单笔最多: "최대 주문 금액",
  日收益率: "일 수익률",
  说明: "설명",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. 데이터 통계 시간은 GMT+8 기준입니다<br>2. 일일 수익은 GMT+8 기준 00:00-23:59 동안의 모든 정산된 주문을 기준으로 계산됩니다<br>3. 당일 수익은 다음날 00:00-00:10 GMT+8 사이에 지급됩니다.",
  知道了: "확인",
  锁仓: "락업",
  派息时间: "배당 시간",
  每日: "매일",
  托管资金: "예치 자금",
  到期返回: "만기 반환",
  提前赎回: "조기 상환",
  预计收益: "예상 수익",
  认购: "청약",
  热门: "인기",
  数字货币: "암호화폐",
  贵金属: "귀금속",
  大宗商品: "원자재",
  持仓明细: "포지션 상세",
  历史明细: "내역",
  当前价: "현재가",
  "↑买涨": "↑ 상승 매수",
  "↓买跌": "↓ 하락 매수",
  显示全部: "전체 보기",
  买入金额: "매수 금액",
  方向: "방향",
  收益: "수익",
  预期收益: "예상 수익",
  估用保证金: "예상 증거금",
  确认下单: "주문 확인",
  锁定: "잠김",
  账户总资产: "총 자산",
  明细: "상세",
  今日收益: "오늘 수익",
  仓位保证金: "포지션 증거금",
  持有仓位: "보유 포지션",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "락업 금액 = 모든 미완료 락업 마이닝 주문의 합계",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. 데이터 통계 시간은 GMT+8 기준입니다<br>2. 일일 수익은 정산된 모든 주문 기준으로 계산됩니다",
  充值方式: "충전 방법",
  银行汇款: "은행 송금",
  "银行汇款请联系客服进行操作!": "은행 송금은 고객센터에 문의하세요!",
  提款方式: "출금 방법",
  "银行提款请联系客服进行操作!": "은행 출금은 고객센터에 문의하세요!",
  资金明细: "자금 내역",
  提现记录: "출금 기록",
  拒绝: "거절",
  通过: "승인",
  拒绝原因: "거절 사유",

  消息公告: "공지사항",
  订单: "주문",
  个人中心: "개인센터",
  "未到期赎回需支付一定的违约金!": "만기 전 상환 시 위약금을 지불해야 합니다.",

  请输入区号: "지역 번호를 입력해 주세요",
  "请选择国家/地区": "국가/지역을 선택해 주세요",

  今日开盘: "오늘 시가",
  昨日收盘: "어제 종가",

  实名认证即送: "실명 인증 완료 후 즉시 받기",
  立即认证: "지금 인증하기",
  新用户礼包: "신규 사용자 선물 패키지",
  完成新人任务领取: "신규 사용자 미션을 완료하고 받기",
  认证: "인증",
  时间周期: "기간",
  支付金额: "결제 금액",
  已平仓: "청산 완료",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX 신규 사용자 환영 패키지: 사용자당 최대 수령 가능",
  我已经阅读并同意: "읽었으며 동의합니다",
  隐私政策: "개인정보 보호정책",

  放弃奖励离开: "보상을 포기하고 나가기",
  继续注册: "회원가입 계속하기",
  分钟: "분",

  "请先勾选隐私政策!": "먼저 개인정보 처리방침을 확인해 주세요!",
  添加其他到自选: "다른 항목을 관심 목록에 추가",

  充值最高可得: "추가 충전하고 최대 30,000달러를 받으세요.",

  请输入格式正确的手机号: "유효한 휴대전화 번호를 입력해 주세요.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};



// WEBPACK FOOTER //
// ./src/lang/ko.js